import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { TasProgramTemplateExtension as TasProgramTemplateModel } from 'tio-data/data/resources/tas-program-template.ext';
import type { Store } from '@warp-drive/core';

export default class AuthenticatedAdminTuitionAssistanceProgramTemplatesShowRoute extends Route {
  @service declare store: Store;

  includes = ['company.company-setting', 'conditions.public-assets'];

  async model(params: { tas_program_template_id: string }) {
    const { content } = (await this.store.request(
      findRecord<TasProgramTemplateModel>('tas-program-template', params.tas_program_template_id, {
        reload: true,
        include: this.includes.join(','),
      })
    )) as { content: { data: TasProgramTemplateModel } };
    return content.data;
  }
}
